<div role="alert" [ngClass]="metric | dsMetricStyleConfig">
  <div #container></div>
</div>
